<div class="ipm-notify-pop">
    <div class="ipm-notify-body">
        <div class="ipm-check-section">
            <i class="las la-check"></i>
        </div>
        <p class="ipm-sub-heading">
            <span [innerHTML]="data?.message"></span>
        </p>
        <div class="ipm-actions" actions>        
            <button mat-flat-button 
                    color="primary"
                    class="primary-button ipm-submit-btn"
                    type="submit"
                    (click)="close()">
                    Okay
            </button>
        </div>
    </div>
</div>